module.exports = __webpack_public_path__ + "static/media/26-3.9334ce03.mp3";